import type { ReactNode } from 'react'
import type { PermissionCode } from '@super-mega/server/contracts/authorization'
import { useAccess } from '@/hooks/use-access.ts'

export function Authorized({
  permissions,
  any,
  children
}: {
  permissions?: readonly PermissionCode[]
  any?: readonly PermissionCode[]
  children: ReactNode
}) {
  const access = useAccess()
  if (permissions && !access.all(permissions)) return null
  if (any && !access.any(any)) return null
  return children
}
